// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   RABBITAI UNIVERSAL RESPONSIVE DESIGN SYSTEM
   100% Zoom & Multi-Resolution Resilience (Desktop, Split-Screen, Laptop, Tablet, Mobile)
   ========================================================================== */

*,
*::before,
*::after {
  box-sizing: border-box;
  min-width: 0;
}

html,
body,
#root {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* ==========================================================================
   1. UNIVERSAL CUSTOM SCROLLBAR
   ========================================================================== */
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.4) transparent;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 9999px;
}

::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.35);
  border-radius: 9999px;
  border: 1px solid transparent;
  background-clip: padding-box;
}

::-webkit-scrollbar-thumb:hover {
  background: #FD6101;
}

::-webkit-scrollbar-corner {
  background: transparent;
}

/* Dark Mode Scrollbars */
[data-theme='dark'] *,
.dark-theme *,
body.dark * {
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

[data-theme='dark'] ::-webkit-scrollbar-thumb,
.dark-theme ::-webkit-scrollbar-thumb,
body.dark ::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
}

/* ==========================================================================
   2. UNIVERSAL MODAL OVERLAY & POPUP RESILIENCE (NO MORE CUTOFFS)
   ========================================================================== */

/* Overlays: Always scrollable from top to bottom, never clips header or footer */
.modal-overlay,
.forgot-modal-overlay,
.matrix-detail-modal-overlay,
div[class*="modal-overlay"],
div[style*="position: fixed"][style*="inset: 0"],
div[style*="position: fixed"][style*="bottom: 0"],
div[style*="position: fixed"][style*="height: 100%"],
div[style*="position: fixed"][style*="height: '100%'"],
div[style*="position: 'fixed'"][style*="bottom: 0"],
div[style*="position: \\"fixed\\""][style*="bottom: 0"] {
  position: fixed !important;
  inset: 0 !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background: rgba(15, 23, 42, 0.65) !important;
  backdrop-filter: blur(6px) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: flex-start !important;
  /* Starts at top so scrolling works naturally without clipping top or bottom */
  z-index: 10005 !important;
  padding: clamp(12px, 3vh, 32px) clamp(8px, 2.5vw, 24px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  -webkit-overflow-scrolling: touch !important;
  box-sizing: border-box !important;
}

/* Modal Cards / Windows: Fits within viewport, scroll inside if content exceeds height */
.modal-card,
.matrix-detail-modal,
.modal-box,
.custom-modal,
div[class*="modal-card"],
.modal-overlay>div,
.forgot-modal-overlay>div,
.matrix-detail-modal-overlay>div {
  max-height: calc(100vh - 48px) !important;
  max-width: min(96vw, 680px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  box-sizing: border-box !important;
  margin: auto 0 !important;
  /* Vertically centered when short, scrollable from top when tall */
  display: flex !important;
  flex-direction: column !important;
  border-radius: 14px !important;
}

/* Wide Modals (Diff views, logs, multi-column forms) */
.modal-card.modal-lg,
.modal-card.modal-xl,
div[style*="width: 850px"],
div[style*="width: 800px"],
div[style*="width: 900px"],
div[style*="width: 1000px"],
div[style*="width: \\"850px\\""] {
  max-width: min(96vw, 1100px) !important;
}

/* Ensure form controls inside modals never overflow */
.modal-card input,
.modal-card textarea,
.modal-card select,
.modal-input-group input,
.modal-input-group textarea,
.modal-input-group select,
.modal-card .gen-input,
.modal-card .gen-select {
  max-width: 100% !important;
  box-sizing: border-box !important;
}

/* Sticky / Safe modal actions footer so Save/Cancel buttons are always reachable */
.modal-card>div[style*="justify-content: flex-end"],
.modal-card>div[style*="justifyContent: \\"flex-end\\""],
.modal-card>div[style*="justifyContent: 'flex-end'"],
.modal-card form>div[style*="justify-content: flex-end"],
.modal-card form>div[style*="justifyContent: \\"flex-end\\""],
.modal-card form>div[style*="justifyContent: 'flex-end'"],
.modal-card form>div:last-child,
.modal-actions,
.modal-footer {
  position: sticky !important;
  bottom: -24px !important;
  background: #ffffff !important;
  padding-top: 14px !important;
  padding-bottom: 4px !important;
  margin-top: auto !important;
  border-top: 1px solid #f1f5f9 !important;
  z-index: 15 !important;
  flex-shrink: 0 !important;
}

/* ==========================================================================
   3. RESPONSIVE HEIGHTS (Handles 100% / 125% Zoom & Laptop Displays)
   ========================================================================== */
@media (max-height: 860px) {

  .modal-card,
  div[class*="modal-card"],
  .modal-overlay>div {
    padding: 18px 20px !important;
    max-height: calc(100vh - 28px) !important;
  }

  .modal-input-group {
    margin-bottom: 12px !important;
  }

  .modal-card textarea {
    height: 85px !important;
    min-height: 60px !important;
  }

  .modal-card h3,
  .modal-title {
    font-size: 16px !important;
    margin-bottom: 12px !important;
  }
}

@media (max-height: 700px) {

  .modal-card,
  div[class*="modal-card"],
  .modal-overlay>div {
    padding: 14px 16px !important;
    max-height: calc(100vh - 16px) !important;
  }

  .modal-input-group {
    margin-bottom: 10px !important;
  }

  .modal-card textarea {
    height: 65px !important;
  }
}

/* ==========================================================================
   4. RESPONSIVE WIDTHS & 100% ZOOM RESILIENCE
   ========================================================================== */
@media (max-width: 1440px) {
  .header-widgets-container {
    display: none !important;
  }

  .mid-section-grid {
    grid-template-columns: 1fr !important;
    gap: 16px !important;
  }

  .metrics-grid {
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 12px !important;
  }

  .creation-cards-row {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)) !important;
    gap: 12px !important;
  }

  .main-content {
    padding: 16px 20px !important;
  }
}

@media (max-width: 1100px) {
  .insights-grid {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)) !important;
  }

  .panel-header-row {
    flex-wrap: wrap !important;
    gap: 12px !important;
  }

  .gen-tabs-row {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;
  }

  .creation-cards-row {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)) !important;
  }
}

@media (max-width: 900px) {
  .metrics-grid {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)) !important;
  }

  .insights-grid {
    grid-template-columns: 1fr !important;
  }

  .main-header {
    padding: 0 16px !important;
    margin: 8px 12px 4px 12px !important;
    border-radius: 16px !important;
    flex-wrap: nowrap !important;
    min-height: 60px !important;
    height: auto !important;
  }
}

/* ==========================================================================
   5. CHARACTER, TEXT & TABLE OVERFLOW PROTECTION
   ========================================================================== */
p,
span,
h1,
h2,
h3,
h4,
h5,
h6,
label,
td,
th,
div {
  overflow-wrap: break-word;
  word-break: normal;
}

/* Code, Log & JSON Containers */
pre,
code,
.code-container,
.code-editor,
.terminal-output,
.log-viewer,
.json-viewer,
.response-container {
  overflow-x: auto !important;
  overflow-y: auto !important;
  max-height: 500px;
  word-break: break-all;
  white-space: pre-wrap;
}

/* Tables & Data Grids */
.table-card,
.table-container,
.table-wrapper,
.responsive-table,
.data-table-wrapper,
div:has(> table) {
  max-width: 100% !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
  border-radius: 8px;
}

table {
  min-width: 100%;
  border-collapse: collapse;
}

/* Navigation & Main Layout */
.sidebar,
.sidebar-container,
aside,
nav {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-height: 100vh;
}

.main-content,
.page-container,
.app-container,
.dashboard-container,
.superadmin-console {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100vh;
  min-width: 0;
}

/* Utility Helpers */
.scrollable-y {
  overflow-y: auto !important;
}

.scrollable-x {
  overflow-x: auto !important;
}

.scrollable-both {
  overflow: auto !important;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E;;;EAGE,sBAAsB;EACtB,YAAY;AACd;;AAEA;;;EAGE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,qFAAqF;EACrF,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,+EAA+E;AACjF;;AAEA;;+EAE+E;AAC/E;EACE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;;;EAGE,sDAAsD;AACxD;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;+EAE+E;;AAE/E,iFAAiF;AACjF;;;;;;;;;;EAUE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,6CAA6C;EAC7C,qCAAqC;EACrC,wBAAwB;EACxB,kCAAkC;EAClC,kCAAkC;EAClC,8EAA8E;EAC9E,yBAAyB;EACzB,kEAAkE;EAClE,2BAA2B;EAC3B,6BAA6B;EAC7B,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA,yFAAyF;AACzF;;;;;;;;EAQE,yCAAyC;EACzC,sCAAsC;EACtC,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;EACjC,yBAAyB;EACzB,kEAAkE;EAClE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA,uDAAuD;AACvD;;;;;;;EAOE,uCAAuC;AACzC;;AAEA,sDAAsD;AACtD;;;;;;;;EAQE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,mFAAmF;AACnF;;;;;;;;;EASE,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,wCAAwC;EACxC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;+EAE+E;AAC/E;;EAEE;;;IAGE,6BAA6B;IAC7B,yCAAyC;EAC3C;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;;IAEE,0BAA0B;IAC1B,8BAA8B;EAChC;AACF;;AAEA;;EAEE;;;IAGE,6BAA6B;IAC7B,yCAAyC;EAC3C;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,gDAAgD;IAChD,oBAAoB;EACtB;;EAEA;IACE,sEAAsE;IACtE,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,sEAAsE;EACxE;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,sEAAsE;EACxE;;EAEA;IACE,sEAAsE;EACxE;AACF;;AAEA;EACE;IACE,sEAAsE;EACxE;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;IAC1B,oCAAoC;IACpC,8BAA8B;IAC9B,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;;AAEA;;+EAE+E;AAC/E;;;;;;;;;;;;EAYE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;;;;;;;;EAQE,2BAA2B;EAC3B,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;;;;;;EAME,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;;;;EAIE,2BAA2B;EAC3B,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;;;;EAKE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB","sourcesContent":["/* ==========================================================================\n   RABBITAI UNIVERSAL RESPONSIVE DESIGN SYSTEM\n   100% Zoom & Multi-Resolution Resilience (Desktop, Split-Screen, Laptop, Tablet, Mobile)\n   ========================================================================== */\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  min-width: 0;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* ==========================================================================\n   1. UNIVERSAL CUSTOM SCROLLBAR\n   ========================================================================== */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(148, 163, 184, 0.4) transparent;\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 9999px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.35);\n  border-radius: 9999px;\n  border: 1px solid transparent;\n  background-clip: padding-box;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #FD6101;\n}\n\n::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n/* Dark Mode Scrollbars */\n[data-theme='dark'] *,\n.dark-theme *,\nbody.dark * {\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\n}\n\n[data-theme='dark'] ::-webkit-scrollbar-thumb,\n.dark-theme ::-webkit-scrollbar-thumb,\nbody.dark ::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n/* ==========================================================================\n   2. UNIVERSAL MODAL OVERLAY & POPUP RESILIENCE (NO MORE CUTOFFS)\n   ========================================================================== */\n\n/* Overlays: Always scrollable from top to bottom, never clips header or footer */\n.modal-overlay,\n.forgot-modal-overlay,\n.matrix-detail-modal-overlay,\ndiv[class*=\"modal-overlay\"],\ndiv[style*=\"position: fixed\"][style*=\"inset: 0\"],\ndiv[style*=\"position: fixed\"][style*=\"bottom: 0\"],\ndiv[style*=\"position: fixed\"][style*=\"height: 100%\"],\ndiv[style*=\"position: fixed\"][style*=\"height: '100%'\"],\ndiv[style*=\"position: 'fixed'\"][style*=\"bottom: 0\"],\ndiv[style*=\"position: \\\"fixed\\\"\"][style*=\"bottom: 0\"] {\n  position: fixed !important;\n  inset: 0 !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  background: rgba(15, 23, 42, 0.65) !important;\n  backdrop-filter: blur(6px) !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: flex-start !important;\n  /* Starts at top so scrolling works naturally without clipping top or bottom */\n  z-index: 10005 !important;\n  padding: clamp(12px, 3vh, 32px) clamp(8px, 2.5vw, 24px) !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  -webkit-overflow-scrolling: touch !important;\n  box-sizing: border-box !important;\n}\n\n/* Modal Cards / Windows: Fits within viewport, scroll inside if content exceeds height */\n.modal-card,\n.matrix-detail-modal,\n.modal-box,\n.custom-modal,\ndiv[class*=\"modal-card\"],\n.modal-overlay>div,\n.forgot-modal-overlay>div,\n.matrix-detail-modal-overlay>div {\n  max-height: calc(100vh - 48px) !important;\n  max-width: min(96vw, 680px) !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  box-sizing: border-box !important;\n  margin: auto 0 !important;\n  /* Vertically centered when short, scrollable from top when tall */\n  display: flex !important;\n  flex-direction: column !important;\n  border-radius: 14px !important;\n}\n\n/* Wide Modals (Diff views, logs, multi-column forms) */\n.modal-card.modal-lg,\n.modal-card.modal-xl,\ndiv[style*=\"width: 850px\"],\ndiv[style*=\"width: 800px\"],\ndiv[style*=\"width: 900px\"],\ndiv[style*=\"width: 1000px\"],\ndiv[style*=\"width: \\\"850px\\\"\"] {\n  max-width: min(96vw, 1100px) !important;\n}\n\n/* Ensure form controls inside modals never overflow */\n.modal-card input,\n.modal-card textarea,\n.modal-card select,\n.modal-input-group input,\n.modal-input-group textarea,\n.modal-input-group select,\n.modal-card .gen-input,\n.modal-card .gen-select {\n  max-width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n/* Sticky / Safe modal actions footer so Save/Cancel buttons are always reachable */\n.modal-card>div[style*=\"justify-content: flex-end\"],\n.modal-card>div[style*=\"justifyContent: \\\"flex-end\\\"\"],\n.modal-card>div[style*=\"justifyContent: 'flex-end'\"],\n.modal-card form>div[style*=\"justify-content: flex-end\"],\n.modal-card form>div[style*=\"justifyContent: \\\"flex-end\\\"\"],\n.modal-card form>div[style*=\"justifyContent: 'flex-end'\"],\n.modal-card form>div:last-child,\n.modal-actions,\n.modal-footer {\n  position: sticky !important;\n  bottom: -24px !important;\n  background: #ffffff !important;\n  padding-top: 14px !important;\n  padding-bottom: 4px !important;\n  margin-top: auto !important;\n  border-top: 1px solid #f1f5f9 !important;\n  z-index: 15 !important;\n  flex-shrink: 0 !important;\n}\n\n/* ==========================================================================\n   3. RESPONSIVE HEIGHTS (Handles 100% / 125% Zoom & Laptop Displays)\n   ========================================================================== */\n@media (max-height: 860px) {\n\n  .modal-card,\n  div[class*=\"modal-card\"],\n  .modal-overlay>div {\n    padding: 18px 20px !important;\n    max-height: calc(100vh - 28px) !important;\n  }\n\n  .modal-input-group {\n    margin-bottom: 12px !important;\n  }\n\n  .modal-card textarea {\n    height: 85px !important;\n    min-height: 60px !important;\n  }\n\n  .modal-card h3,\n  .modal-title {\n    font-size: 16px !important;\n    margin-bottom: 12px !important;\n  }\n}\n\n@media (max-height: 700px) {\n\n  .modal-card,\n  div[class*=\"modal-card\"],\n  .modal-overlay>div {\n    padding: 14px 16px !important;\n    max-height: calc(100vh - 16px) !important;\n  }\n\n  .modal-input-group {\n    margin-bottom: 10px !important;\n  }\n\n  .modal-card textarea {\n    height: 65px !important;\n  }\n}\n\n/* ==========================================================================\n   4. RESPONSIVE WIDTHS & 100% ZOOM RESILIENCE\n   ========================================================================== */\n@media (max-width: 1440px) {\n  .header-widgets-container {\n    display: none !important;\n  }\n\n  .mid-section-grid {\n    grid-template-columns: 1fr !important;\n    gap: 16px !important;\n  }\n\n  .metrics-grid {\n    grid-template-columns: repeat(3, 1fr) !important;\n    gap: 12px !important;\n  }\n\n  .creation-cards-row {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)) !important;\n    gap: 12px !important;\n  }\n\n  .main-content {\n    padding: 16px 20px !important;\n  }\n}\n\n@media (max-width: 1100px) {\n  .insights-grid {\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)) !important;\n  }\n\n  .panel-header-row {\n    flex-wrap: wrap !important;\n    gap: 12px !important;\n  }\n\n  .gen-tabs-row {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;\n  }\n\n  .creation-cards-row {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)) !important;\n  }\n}\n\n@media (max-width: 900px) {\n  .metrics-grid {\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)) !important;\n  }\n\n  .insights-grid {\n    grid-template-columns: 1fr !important;\n  }\n\n  .main-header {\n    padding: 0 16px !important;\n    margin: 8px 12px 4px 12px !important;\n    border-radius: 16px !important;\n    flex-wrap: nowrap !important;\n    min-height: 60px !important;\n    height: auto !important;\n  }\n}\n\n/* ==========================================================================\n   5. CHARACTER, TEXT & TABLE OVERFLOW PROTECTION\n   ========================================================================== */\np,\nspan,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nlabel,\ntd,\nth,\ndiv {\n  overflow-wrap: break-word;\n  word-break: normal;\n}\n\n/* Code, Log & JSON Containers */\npre,\ncode,\n.code-container,\n.code-editor,\n.terminal-output,\n.log-viewer,\n.json-viewer,\n.response-container {\n  overflow-x: auto !important;\n  overflow-y: auto !important;\n  max-height: 500px;\n  word-break: break-all;\n  white-space: pre-wrap;\n}\n\n/* Tables & Data Grids */\n.table-card,\n.table-container,\n.table-wrapper,\n.responsive-table,\n.data-table-wrapper,\ndiv:has(> table) {\n  max-width: 100% !important;\n  overflow-x: auto !important;\n  overflow-y: auto !important;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 8px;\n}\n\ntable {\n  min-width: 100%;\n  border-collapse: collapse;\n}\n\n/* Navigation & Main Layout */\n.sidebar,\n.sidebar-container,\naside,\nnav {\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  max-height: 100vh;\n}\n\n.main-content,\n.page-container,\n.app-container,\n.dashboard-container,\n.superadmin-console {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 100vh;\n  min-width: 0;\n}\n\n/* Utility Helpers */\n.scrollable-y {\n  overflow-y: auto !important;\n}\n\n.scrollable-x {\n  overflow-x: auto !important;\n}\n\n.scrollable-both {\n  overflow: auto !important;\n}\n\n.no-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.no-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
